export default __webpack_public_path__ + "static/livecasts-logo-2efa838c832daea7a7e66ef5bd22557e.svg";